import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

export const usePageTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname, document.title);
  }, [pathname]);
};
